import React from 'react'
import { useMediaContext } from '@gopeerproject/web-kit'

import { ClassroomManager, redirectToCore } from '@helpers'
import { Classroom as ClassroomConstants } from '@constants'
import { useClassroomEnv } from '@components/ClassroomEnv'

import { useClassroomDispatch } from '../../../../hooks'
import { IconButton } from '@gopeerproject/ui-kit'

const EndCallButton = () => {
  const { env } = useClassroomEnv()
  const classroomDispatch = useClassroomDispatch()
  const { room } = useMediaContext()

  return (
    <IconButton
      type='tertiary'
      size='lg'
      accent='negative'
      active
      onPress={() => {
        switch (env) {
          case ClassroomConstants.ENV.CLASSROOM:
            room?.disconnect()
            ClassroomManager.destroy()
            classroomDispatch({
              type: 'set_step',
              payload: ClassroomConstants.STEPS.COMPLETED
            })
            break
          case ClassroomConstants.ENV.PLAYGROUND:
            ClassroomManager.destroy()
            redirectToCore()
        }
      }}
      value='call-end'
    />
  )
}

export default EndCallButton
